import React from 'react';
import Chart from "react-apexcharts";
import { useViewCountryReport } from "../../hooks/reports/country";

const UsersPieChart = () => {
  const { data, loading, error } = useViewCountryReport();

  const countryData = data || [];

  const series = countryData.map(item => Number(item.count));

  const labels = countryData.map(
    item => `${item.country} (${item.percentage}%)`
  );

  const options = {
    chart: {
      type: 'pie',
    },
    labels: labels,
    title: {
      text: 'Distributors by Country',
      align: 'left',
      style: {
        fontSize: '20px',
        color: '#333'
      }
    },
    legend: {
      position: 'bottom'
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          const idx = opts.seriesIndex;
          const item = countryData[idx];
          return `${item.country}: ${val} users (${item.percentage}%)`;
        }
      }
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading chart data.</div>;

  return (
    <div
      className="pieChart"
      style={{
        width: '100%',
        background: '#b4c1f223',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}
    >
      <Chart
        options={options}
        series={series}
        type="pie"
        height={350}
        width="100%"
      />
    </div>
  );
};

export default UsersPieChart;
